import { useEffect, type Dispatch, type SetStateAction } from 'react'

import { type Column, Table } from '../../../../../../components/Table'
import { useClientContactsQuery } from '../../../../../../services/hooks/clientContacts/queries/useClientContactsQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type Props = {
  clientId: number
  filters: FiltersDomain
  columns: Column[]
  setFilters: Dispatch<SetStateAction<FiltersDomain>>
}
export const TableWithManuallyPagination = ({
  clientId,
  filters,
  columns,
  setFilters,
}: Props) => {
  const { data, refetch } = useClientContactsQuery(clientId, filters)

  useEffect(() => {
    refetch()
  }, [])

  return (
    <Table
      columns={columns}
      rows={data?.data || []}
      currentPage={filters.page}
      registersPerPage={filters.take}
      totalCountOfRegisters={data?.meta?.itemCount}
      noContentMessage="Sem registro de contato(s)"
      onPageChange={(pageNumber) =>
        setFilters((prevState) => ({
          ...prevState,
          page: pageNumber,
        }))
      }
      onChangingRegistersPerPage={(registersPerPage) => {
        setFilters((prevState) => ({
          ...prevState,
          page: 1,
          take: registersPerPage,
        }))
      }}
    />
  )
}
